import React, {createContext, ReactNode, useEffect, useState} from 'react';
import {authService} from "../services/auth.service";

interface ContextProps {
    entities: any[];
    loading: boolean;
    getEntityById: (id: number) => any | undefined;
    isAdminExists: boolean;
    isAdminLoading: boolean;
    setIsAdminExists: (value: boolean) => void;
}

const Context = createContext<ContextProps | undefined>(undefined);

export const Provider = ({children}: {children: ReactNode}) => {
    const [entities, setEntities] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [isAdminExists, setIsAdminExists] = useState<boolean>(false);
    const [isAdminLoading, setIsAdminLoading] = useState<boolean>(true);

    useEffect(() => {
        authService.hasSystemAdminPrivilege().then((data) => {
            setIsAdminExists(data)
        }).catch(() => {
            setIsAdminExists(false);
        }).finally(() => {
            setIsAdminLoading(false);
        });
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setEntities([]);
            } catch (error) {
                console.error('Error loading data:', error);
            } finally {
                setLoading(false);
            }
        };

        void fetchData();
    }, []);

    const getEntityById = (id: number): any | undefined => {
        return entities.find(entity => entity.id === id);
    };

    return (
        <Context.Provider value={{entities, loading, getEntityById, isAdminExists, isAdminLoading, setIsAdminExists}}>
            {children}
        </Context.Provider>
    );
};

export const useContext = () => {
    const context = React.useContext(Context);
    if (context === undefined) {
        throw new Error('useContext must be used within a Provider');
    }
    return context;
};
